module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaAgMAAADDBjSUAAAACVBMVEUAAADHx83Hx8zSFYoLAAAAAnRSTlMAgJsrThgAAAAxSURBVAjXY2BlAAIpByCRNQFELAFxVwIJtlVAQcZVhATBBJgLlgArwScEtghqJdhyAKT9FkUfi5NzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-right.png
// module id = 2042
// module chunks = 6